import { render, staticRenderFns } from "./CRMActionRecord.vue?vue&type=template&id=1933f760&scoped=true&"
import script from "./CRMActionRecord.vue?vue&type=script&lang=js&"
export * from "./CRMActionRecord.vue?vue&type=script&lang=js&"
import style0 from "./CRMActionRecord.vue?vue&type=style&index=0&id=1933f760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933f760",
  null
  
)

export default component.exports